import { createFileRoute, Outlet } from "@tanstack/react-router";
import { HeaderSimple } from "@/components/marketing/header-navigation/header-simple";
import { HeaderNavigationBase } from "@/components/application/app-navigation/header-navigation";
import { Footer } from "@/components/marketing/footer/footer";
import { useAuthStore } from "@/stores/authStore";
import { useCookieConsentStore } from "@/stores/cookieConsentStore";
import { appNavItems } from "@/config/navigation";
import { cx } from "@/utils/cx";

export const Route = createFileRoute("/_marketing")({
  component: MarketingLayout,
});

function MarketingLayout() {
  const { isAuthenticated } = useAuthStore();
  const consentStatus = useCookieConsentStore((state) => state.status);

  return (
    <div
      className={cx("flex min-h-screen flex-col", consentStatus === "pending" && "pb-24")}
      data-marketing-typography
    >
      {isAuthenticated ? <HeaderNavigationBase items={appNavItems} /> : <HeaderSimple />}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
